/**
 * Drawer configuration schema.
 * Defines all navigation drawer sections and their items.
 *
 * @key Unique translation key for localization.
 * @icon Material Design icon name.
 * @path Target route path.
 */
export const drawerConfig = {
  /**
   * Items shown to corporate (non-OTP) users.
   * Routes: /app/corporate/*
   */
  corporateOverview: [
    {
      key: "allVisits",
      icon: "mdi-account-multiple-outline",
      path: "/app/corporate/all-visits",
    },
    {
      key: "newResults",
      icon: "mdi-test-tube",
      path: "/app/corporate/new-results",
    },
    {
      key: "search",
      icon: "mdi-magnify",
      path: "/app/corporate/search",
    },
    {
      key: "starred",
      icon: "mdi-star-outline",
      path: "/app/corporate/starred",
    },
  ],

  /**
   * Items shown to OTP patient users.
   * Path base only — patientId is appended at runtime in useDrawer.
   * Routes: /app/otp-patient/results/:id and /app/otp-patient/balance/:id
   */
  otpPatientOverview: [
    {
      key: "results",
      icon: "mdi-file-document-outline",
      path: "/app/otp-patient/results",
    },
    {
      key: "balance",
      icon: "mdi-cash-multiple",
      path: "/app/otp-patient/balance",
    },
  ],

  about: [
    {
      key: "about",
      icon: "mdi-information-outline",
      path: "/app/about",
    },
  ],

  /**
   * Dev-only items — visible only when LAB_PORTAL_FE_DEV=true.
   * Routes: /app/dev/*
   */
  dev: [
    {
      key: "uiStates",
      icon: "mdi-palette-swatch-outline",
      path: "/app/dev/ui-states",
    },
  ],
};
